import React from "react";
import styles from "./about.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useRef, useEffect, useState } from "react";

function About() {
  const navigate = useNavigate(); // Initialize navigation

  const infoLink = () => {
    const infoSection = document.getElementById("ecosystem");
    if (infoSection) {
      window.scrollTo({
        top: infoSection.offsetTop, // Get the top position
        behavior: "smooth", // Smooth scrolling
      });
    }
  };

  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  return (
    <div id="about" className={styles.about_wrapper}>
      <div className={styles.about_container}>
        <section className={styles.left}>
          <h2>Our Idea</h2>
          <p
            ref={pRef}
            className={`${styles.leftP} ${isVisible ? styles.show : ""}`}>
            Our goal is to establish strategic partnerships with companies
            offering tangible or intangible products seeking to enter the global
            market. By acting as a key access point, we aim to facilitate their
            international market entry and distribution. Simultaneously, we
            strive to become a reliable sourcing partner, capable of identifying
            and supplying products in demand by wholesale or chain business
            worldwide. Through these efforts, we will create value for our
            partners while expanding our own market presence and reach.
          </p>
          <div className={styles.leftIMGWrapper}>
            <div className={styles.leftIMG}></div>
          </div>
        </section>

        <section className={styles.right}>
          <div className={styles.rightMarket}>
            <h2>Market Potential</h2>
            <div
              ref={pRef}
              className={`${styles.rightNumber} ${
                isVisible ? styles.show : ""
              }`}>
              <h3>$49.9t ~ $53t</h3>
              <p>And growing</p>
            </div>

            <div className={styles.rightPotential}>
              <div className={styles.dollar}>
                <p>
                  <span className={styles.sartdollar}>$5m </span>{" "}
                  <span>$125M</span>
                </p>
              </div>
              <div className={styles.line}>
                <span></span>
              </div>
              <div className={styles.paragraph}>
                <p>
                  Softcap in 879 days <span>Hardcap</span>
                </p>
              </div>
            </div>

            {/* Correct way to navigate on button click */}
            <button className={styles.aboutBTN} onClick={infoLink}>
              GET MORE INFO
            </button>

            <p
              ref={pRef}
              className={`${styles.rightP} ${isVisible ? styles.show : ""}`}>
              BusinessCorners is a Europe-based company where buyers and sellers
              meet to conduct operations involving goods, assets, and services
              with us. Our unique advantage lies in helping companies establish
              sustainable markets, based on continuous research and development.
              By leveraging data-driven insights and industry trends, we enable
              businesses to adapt toevolving market demands. Our platform
              fosters collaboration, ensuring that both buyers and sellers
              benefit from transparent, efficient, and innovative solutions.
              With a focus on sustainability, we aim to create long-term value
              for all stakeholders involved.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;
